import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button } from 'antd';
import { buttonLabel } from '../../../constants';
import { setPreviousPath } from '../../../appRedux/actions/General';
import './styles.css';

export const CancelButton = ({ path }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  /**
   * Función para regresar guardando el path anterior
   */
  const handleCancel = useCallback(() => {
    dispatch(setPreviousPath(path));
    navigate(path);
  }, [navigate, path, dispatch]);

  return (
    <>
      <Button
        type="danger"
        className="danger-button"
        onClick={handleCancel}
      >
        {buttonLabel.cancel}
      </Button>
    </>
  );
};
